import { summarise } from '../../lib/spans.js';
import { Keycap } from '../common/index.jsx';

/**
 * Switch between the three captions of an image.
 *
 * One caption is on screen at a time, as in the old tool's caption-source switch:
 * stacking all three wasted most of the vertical space on text the annotator was not
 * currently judging. Each button carries its tag counts and a tick when submitted, so
 * the state of the whole image is still visible at a glance.
 */
export function CaptionSwitcher({ drafts, focusedSlot, onSelect }) {
  return (
    <div className="caption-switcher" role="tablist" aria-label="Captions for this image">
      {drafts.map((draft, slot) => {
        const counts = summarise(draft.spans);
        const total = counts.hallucinated + counts.uncertain + counts.wrong_uncertainty;
        const done = draft.status === 'submitted' || draft.status === 'approved';
        const active = slot === focusedSlot;

        return (
          <button
            key={draft.sampleId}
            type="button"
            role="tab"
            aria-selected={active}
            className={`caption-tab ${active ? 'active' : ''}`}
            onClick={() => onSelect(slot)}
          >
            <span className="caption-tab-name">
              {done && <span className="tick" aria-label="submitted">✓</span>}
              Caption {draft.label}
            </span>

            <span className="caption-tab-counts">
              {total === 0 ? (
                <span className="faint">no tags</span>
              ) : (
                <>
                  {counts.hallucinated > 0 && (
                    <span className="dot hallucinated" title={`${counts.hallucinated} hallucination`}>
                      {counts.hallucinated}
                    </span>
                  )}
                  {counts.uncertain > 0 && (
                    <span className="dot uncertain" title={`${counts.uncertain} uncertain`}>
                      {counts.uncertain}
                    </span>
                  )}
                  {counts.wrong_uncertainty > 0 && (
                    <span className="dot wrong_uncertainty" title={`${counts.wrong_uncertainty} wrong uncertainty`}>
                      {counts.wrong_uncertainty}
                    </span>
                  )}
                </>
              )}
              {draft.dirty && <span className="dot unsaved" title="unsaved changes" />}
            </span>

            <Keycap>{slot + 1}</Keycap>
          </button>
        );
      })}
    </div>
  );
}
